import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { getStrictCurrentEnterpriseId } from '@mews-commander/core';
import { AuthenticatorType, useRepositoryQuery } from '@mews-commander/data-access';
import { Configure2FADeviceConfig } from './Configure2FADeviceConfig';
import { Configure2FADeviceForm } from './Configure2FADeviceForm';
import { Configure2FADeviceSuccess } from './Configure2FADeviceSucess';

export enum Configure2FADeviceRoute {
    config = 'config',
    form = 'form',
    success = 'success',
}

export const Configure2FADevice = () => {
    const navigate = useNavigate();
    const [route, setRoute] = useState(Configure2FADeviceRoute.config);
    const { data: authenticator, isPending } = useAuthenticationConfig();
    const [recoveryPins, setRecoveryPins] = useState<string[]>([]);

    return (
        <>
            {route === Configure2FADeviceRoute.config && (
                <Configure2FADeviceConfig
                    authenticator={authenticator}
                    isPending={isPending}
                    onCancel={() => void navigate({ to: '/Home/Configure2FA/Index' })}
                    onSuccess={() => setRoute(Configure2FADeviceRoute.form)}
                />
            )}
            {route === Configure2FADeviceRoute.form && (
                <Configure2FADeviceForm
                    authenticator={authenticator}
                    onCancel={() => setRoute(Configure2FADeviceRoute.config)}
                    onSuccess={(newRecoveryPins) => {
                        setRecoveryPins(newRecoveryPins);
                        setRoute(Configure2FADeviceRoute.success);
                    }}
                />
            )}
            {route === Configure2FADeviceRoute.success && (
                <Configure2FADeviceSuccess
                    recoveryPins={recoveryPins}
                    onSuccess={() =>
                        void navigate({
                            to: '/$currentEnterpriseId/Dashboard/Index',
                            params: { currentEnterpriseId: getStrictCurrentEnterpriseId() },
                        })
                    }
                />
            )}
        </>
    );
};

function useAuthenticationConfig() {
    return useRepositoryQuery(
        'users',
        'getAuthenticatorConfiguration',
        { authenticator: AuthenticatorType.Google },
        { refetchOnMount: 'always' }
    );
}
